import { RefObject, useEffect, useState } from 'react';

const useKeysCurrentlyDown = (
  ref: RefObject<HTMLElement> = { current: document.body }
): string[] => {
  const [keysCurrentlyDown, setKeysCurrentlyDown] = useState<string[]>([]);

  useEffect(() => {
    if (!ref.current) return;

    const refCurrent = ref.current;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (!keysCurrentlyDown.includes(e.key)) {
        setKeysCurrentlyDown([...keysCurrentlyDown, e.key]);
      }
    };

    const handleKeyUp = (e: KeyboardEvent) => {
      setKeysCurrentlyDown(keysCurrentlyDown.filter((key) => key !== e.key));
    };

    refCurrent.addEventListener('keydown', handleKeyDown);
    refCurrent.addEventListener('keyup', handleKeyUp);

    return function cleanup() {
      refCurrent.removeEventListener('keydown', handleKeyDown);
      refCurrent.removeEventListener('keyup', handleKeyUp);
    };
  }, [ref, keysCurrentlyDown]);

  return keysCurrentlyDown;
};

export default useKeysCurrentlyDown;
